import { resolveAppMetadataForActivity } from '@/lib/activityOperations/activityOperationMetadata.js';
import { toTimestampMs } from '@/lib/activityOperations/activityOperationTime.js';
import normalizeText from '@/lib/normalizeText.js';
import toReadableGovernanceLabel from '@/lib/settings/governance/toReadableGovernanceLabel.js';
import { EMPTY_ARRAY } from '@/redux/selectors/pieveSelectors/constants.js';

export const resolveMatchingGovernanceResponse = (response, requestKey) => {
  if (!response || !requestKey || response?.meta?.requestKey !== requestKey) {
    return null;
  }

  return response;
};

export const buildGovernanceTimelineBuckets = (items = []) => {
  return (Array.isArray(items) ? items : [])
    .map((item, index) => {
      const bucketStartMs = toTimestampMs(item?.bucketStart);
      const bucketEndMs = toTimestampMs(item?.bucketEnd);

      if (!Number.isFinite(bucketStartMs) || !Number.isFinite(bucketEndMs) || bucketEndMs <= bucketStartMs) {
        return null;
      }

      return {
        id: `dashboard-bucket-${index + 1}`,
        bucketStartMs,
        bucketEndMs,
        create: Number(item?.create || 0),
        update: Number(item?.update || 0),
        delete: Number(item?.delete || 0)
      };
    })
    .filter(Boolean);
};

export const readGovernanceRows = (response) => {
  if (!response || response.success !== true || !Array.isArray(response?.data)) {
    return EMPTY_ARRAY;
  }

  return response.data;
};

const findFirstMatchingGovernanceRow = ({ feedRows = EMPTY_ARRAY, searchRows = EMPTY_ARRAY } = {}) => {
  return searchRows[0] || feedRows[0] || null;
};

export const findGovernanceAppName = ({ appMetadataLookup = null, appId = '', feedRows = EMPTY_ARRAY, searchRows = EMPTY_ARRAY } = {}) => {
  const metadata = resolveAppMetadataForActivity({
    appMetadataLookup,
    appId,
    appSlug: appId
  });
  const firstRow = findFirstMatchingGovernanceRow({
    feedRows,
    searchRows
  });

  return normalizeText(metadata?.name || firstRow?.appName) || toReadableGovernanceLabel(appId, 'App');
};

export const findGovernanceEntityTypeLabel = ({ entityType = '', feedRows = EMPTY_ARRAY, searchRows = EMPTY_ARRAY } = {}) => {
  const normalizedEntityType = entityType.toLowerCase();
  const matchingRow = [...searchRows, ...feedRows].find((row) => {
    return normalizeText(row?.entityType).toLowerCase() === normalizedEntityType || normalizeText(row?.entityTypeLabel).toLowerCase() === normalizedEntityType;
  });

  return normalizeText(matchingRow?.entityTypeLabel) || toReadableGovernanceLabel(entityType, 'Records');
};
